import { createFileRoute } from "@tanstack/react-router";

import QuestOverview from "@/components/QuestProfile/QuestOverview";

const Component = () => {
  const { questUuid } = Route.useParams();
  return <QuestOverview questUuid={questUuid} />;
};

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid")({
  component: Component,
  beforeLoad: () => {
    return {
      switchVenueLinkOpts: {
        path: "/gym/$venueUuid/loyalty/quests",
      },
    };
  },
});
